import { useContext } from 'react';
import { UserFlagContext } from '../contexts/UserFlagContext';

// ----------------------------------------------------------------------

const useUserFlagContext = () => useContext(UserFlagContext);

export default useUserFlagContext;
